import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthGuard } from '../auth/auth.guard';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InfoReportGuard extends AuthGuard  {

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean  {
    if (sessionStorage.getItem(environment.authTokenStorageKey) !== null &&
      Number.parseInt(sessionStorage.getItem(environment.authTokenExpiresStorageKey)) >= Date.now()) {

      let hasAuth: Promise<boolean> | boolean = false;

      if (next.data['authRoleUserType']) {
        if (hasAuth = this.hasRequiredRoleUserType(next.data['authRoleUserType'])) {
          return hasAuth;
        } else {
          return this.hasIRAssignment();
        }
      }
    }

    this.router.navigate(['/login'], { queryParams: { redirectUrl: state.url } });
    return false;
  }

  hasIRAssignment(redirectToHome: boolean = true): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const hasIR: boolean = !!sessionStorage.getItem(this.infoReportService.hasInfoReportStorageKey);
      if (hasIR) {
        resolve(true);
      } else {
        this.infoReportService.getUserIsAssignedToIR().subscribe({
          next: (isAssigned: boolean) => {
            if (!isAssigned) {
              if (redirectToHome) {
                this.router.navigateByUrl('/home');
              };
              resolve(false);
           }
            resolve(isAssigned);
          },
          error: (err:any) => {
            resolve(false);
          }
        });
      }
    });
  }
}
